<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.waitDeal" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        applyTypeOptions: [], // 费用类型
        stateOptions: [], // 维保状态
        orgIdOptions: [], // 部门
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'waitDeal',
            default: true,
            slot: true,
          },
          { // 申请单号
            label: '申请单号',
            value: 'applyCode',
            type: 'input',
            default: this.$route.query.applyCode,
            placeholder: '请输入申请单号',
          },
          { // 申请时间
            label: '申请时间',
            value: 'ApplyTime',
            type: 'date',
            default: [],
            placeholder: '请选择申请时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 费用类型
            label: '费用类型',
            value: 'applyType',
            type: 'select',
            default: -1,
            placeholder: '请选择费用类型',
          },
          { // 维保状态
            label: '维保状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择维保状态',
          },
          { // 部门
            label: '部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择部门',
          },
          { // 申请人
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          { // 账单编号
            label: '账单编号',
            value: 'billCode',
            type: 'input',
            placeholder: '请输入账单编号',
          },
          { // 预估值
            label: '预估值',
            value: 'PreAmt',
            type: 'inputrange',
            default: [],
            placeholder: '请输入预估值',
          },
          { // 维保值
            label: '维保值',
            value: 'TransAmt',
            type: 'inputrange',
            default: [],
            placeholder: '请输入维保值',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.applyCode': function (newVal) {
      if (this.$route.path === '/manage/cost/car/apply') {
        this.$refs.searchBox.setVal('applyCode', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.ApplyTime) {
        searchBoxData.startApplyTime = this.formatDate(searchBoxData.ApplyTime[0], 1);
        searchBoxData.endApplyTime = this.formatDate(searchBoxData.ApplyTime[1], 1);
        delete searchBoxData.ApplyTime;
      }

      // 预估值
      if (searchBoxData.PreAmt) {
        searchBoxData.lePreAmt = searchBoxData.PreAmt[0];
        searchBoxData.gePreAmt = searchBoxData.PreAmt[1];
        delete searchBoxData.PreAmt;
      }
      // 维保值
      if (searchBoxData.TransAmt) {
        searchBoxData.leTransAmt = searchBoxData.TransAmt[0];
        searchBoxData.geTransAmt = searchBoxData.TransAmt[1];
        delete searchBoxData.TransAmt;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await getDepartmentAllList(),
    ];
    const enumsList = await getEnumList({
      codeType: 'REPAIR_APPLY_TYPE,REPAIR_APPLY_STATE',
    });
    this.searchBoxData.applyTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
